import LexisMiskey from "./lexis-miskey";

export default LexisMiskey;

export {
    LexisMiskey,
}